var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomDrawer',{ref:"CustomDrawer",attrs:{"title":_vm.title},on:{"openedCallback":_vm.openedCallback,"handleConfirm":_vm.handleConfirm}},[_c('CustomForm',{ref:"CustomForm",attrs:{"form-model":_vm.formModel,"form-items":_vm.formItem,"form-rules":_vm.formRules}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }